/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {signal} from '@preact/signals-react';

/**
 * Whether the job about to be created should be watched.
 *
 * A signal rather than component state for two reasons.
 *
 * It has to outlive the dialog. `addJob` dispatches `JOB_CREATE_RESPONSE` and
 * hides the editor in the same tick, so the component is gone before the job
 * id exists; `useAutoWatchCreatedJob`, mounted for the whole of the dialog's
 * lifetime, reads this once the id lands.
 *
 * And the two surfaces which own the answer render in different parts of the
 * dialog - the banner above the selected devices, the switch beside the
 * Account Name chooser - so they are separate components with no state to
 * share. `CreateJobNotificationsBanner` publishes here when its button is
 * pressed; `CreateJobNotificationsToggle` seeds this from the stored default
 * on every open and renders from it.
 *
 * `false` is the safe default: ADM only passes the two slots when the feature
 * flag is on, so with the flag off nothing writes this and nothing is ever
 * auto-watched.
 *
 * This is a per-dialog answer, not a live-updates concern, which is why it
 * does not live in `liveUpdates.ts` beside the flag and the socket state.
 */
export const notifyOnCreatedJob = signal<boolean>(false);

export const setNotifyOnCreatedJob = (value: boolean): void => {
  notifyOnCreatedJob.value = value;
};
